import { createApp } from 'vue'
import BooklistReviewsIsland from './BooklistReviewsIsland.vue'

export const BOOKLIST_REVIEWS_ISLAND_ID = 'booklist-reviews-island'

export function mountBooklistReviewsIsland() {
  const el = document.getElementById(BOOKLIST_REVIEWS_ISLAND_ID)
  if (!el || el.dataset.islandMounted === 'true') return
  const targetId = (el.dataset.booklistId || '').trim()
  if (!targetId) {
    console.error('[booklist-reviews] missing data-booklist-id')
    return
  }
  el.dataset.islandMounted = 'true'
  el.innerHTML = ''
  createApp(BooklistReviewsIsland, { target: 'booklist', targetId }).mount(el)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBooklistReviewsIsland)
  } else {
    mountBooklistReviewsIsland()
  }
}
